import * as React from 'react';
import styled, { css } from 'styled-components';
import type Immutable from 'immutable';

import LogViewHeader from 'logview/components/LogViewHeader';
import LogViewCell from 'logview/components/LogViewCell';
import LogViewRow from 'logview/components/LogViewRow';
import { Skeleton } from 'components/common';
import BulkSelectCell from 'logview/components/BulkSelectCell';
import RowCheckbox from 'components/common/EntityDataTable/RowCheckbox';
import { CELL_SEP } from 'logview/Constants';

const ROWS_AMOUNT = 5;

const Table = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-anchor: none;
    overflow-y: auto;
    position: relative;
    gap: ${theme.spacings.xxs};
    height: 100%;
  `,
);

const TableInner = styled.div`
  /* Remove bottom border of last row of last page */
  > *:last-child > *:last-child {
    border-bottom: 0;
  }
`;

const SkeletonContainer = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacings.xs} 0;
  `,
);

type Props = {
  columns: Immutable.Set<string>;
};

const LogViewSkeleton = ({ columns }: Props) => (
  <Table>
    <TableInner>
      <LogViewHeader columns={columns} displayBulkSelectCol />

      {Array.from({ length: ROWS_AMOUNT }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <LogViewRow key={`row-skeleton-${index}`}>
          <BulkSelectCell>
            <RowCheckbox
              onChange={() => {}}
              title="Checkbox placeholder"
              checked={false}
              disabled
              aria-label="Checkbox placeholder"
            />
          </BulkSelectCell>
          {columns.toArray().map((fieldName) => (
            <React.Fragment key={`row-skeleton-fragment-${fieldName}`}>
              <LogViewCell fieldName={fieldName} key={`row-skeleton-${fieldName}`}>
                <SkeletonContainer>
                  <Skeleton height={10} width="60%" />
                </SkeletonContainer>
              </LogViewCell>
              {fieldName !== columns.last() ? CELL_SEP : null}
            </React.Fragment>
          ))}
        </LogViewRow>
      ))}
    </TableInner>
  </Table>
);

export default LogViewSkeleton;
